'use client'

import { TooltipProvider } from '@keffeclaims/ui-web'
import type { ReactNode } from 'react'

/**
 * Workaround pro build atual do @keffeclaims/ui-web que não preserva
 * `"use client"` directive via tsup — Radix Tooltip usa createContext e
 * quebra em Server Components.
 *
 * Issue: tsup precisa do plugin `esbuild-plugin-preserve-directives`
 * ou equivalente pra re-emitir o directive. Até isso ser feito no DS,
 * este wrapper blinda o consumer (Next App Router layout é server).
 */
export function TooltipProviderClient({ children }: { children: ReactNode }) {
  return <TooltipProvider delayDuration={0}>{children}</TooltipProvider>
}
